import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getPublicUser = async ({
  data: { userId },
}: SWRFetcherData<{ userId: string }>) => {
  // get api service
  const api = apiGetService()

  try {
    // retrieve public user
    const { user } = await api.userApi.getPublicUser(userId)

    // return payload
    return { user, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return payload
    return { user: undefined, error: message }
  }
}

const fetcher = (args: SWRFetcherData<{ userId: string }>) => getPublicUser(args)

export const useUserPublic = (userId: string) => {
  const shouldFetch = !!userId

  const { data, isLoading, mutate } = useSWR(
    shouldFetch ? { key: SWRKeys.UseUserPublic, data: { userId } } : null,
    fetcher,
    { revalidateOnFocus: false },
  )

  return {
    user: data?.user,
    isLoading,
    isError: data?.error,
    mutate,
  }
}
